module.exports = __webpack_public_path__ + "img/客户预开户操作手册4852.d41f5eb6.png";